import PlusIcon from '@/components/icons/PlusIcon'
import BlendedImage from '@/components/ui/BlendedImage'
import ContentWrapper from '@/components/ui/ContentWrapper'
import { Link } from '@/i18n/routing'
import Image from 'next/image'

const HomeBielefieldInfo = () => {
  return (
    <ContentWrapper tag="article" className="rounded-3xl overflow-hidden">
      <Link className="grid grid-cols-4 lg:grid-cols-12 col-span-full " href={{ pathname: '/projekte/[slug]', params: { slug: 'matchyourfuture' } }}>
        <div className="relative  col-span-full min-h-72 lg:col-span-8 lg:min-h-none">
          <div className="absolute top-0 left-0 mt-16 z-10 h-12">
            <Image
              width={3000}
              height={1007}
              // h-12 bei w-auto ergibt rund 145 px Breite; ohne sizes kam die 3840px-Variante.
              sizes="160px"
              src="/images/logos/deutscher-agenturpreis-logo.jpeg"
              alt="Deutscher Agenturpreis black logo on the white background"
              className="w-auto h-full object-cover"
            />
          </div>

          <BlendedImage
            blended="luminosity"
            width={4096}
            height={2731}
            sizes="(min-width:1024px) 66vw, 100vw"
            src="/images/content/bie-match-your-future-laptop.png"
            alt="Woman holding a laptop in her hands"
          />
        </div>
        <article className="relative col-span-full lg:col-span-4 flex flex-col w-full h-full">
          <div className="hidden lg:block relative grow">
            <div className="absolute top-0 left-0 w-full h-full bg-KMRS-Darkmode" />

            <BlendedImage
              blended="luminosity"
              className="w-full h-full object-cover object-left mix-blend-luminosity"
              width={3464}
              height={2000}
              src="/images/content/myf-mobile-mockup.jpg"
              alt="MYF Mobile Mockup"
            />
          </div>
          <div className="bg-accent p-8">
            <PlusIcon size={20} color={'#fff'} className="w-5 h-5 mb-8 object-cover" />
            <p className="text-white leading-6 text-lg font-light">
              <strong className="font-medium"> Bielefeld </strong>
              <br />
              Fachkräfte Kampagne <br />
              Konzeption & Entwicklung
            </p>
          </div>
        </article>
      </Link>
    </ContentWrapper>
  )
}

export default HomeBielefieldInfo
